import React from "react";
import { connect } from "react-redux";

class Dimensions extends React.Component {
  render() {
    let dimensions = null;

    if (this.props.productOption) {
      if (this.props.productOption.display_dimensions) {
        dimensions = this.props.productOption.display_dimensions;
      } else if (
        this.props.productOption.product_width_inches &&
        this.props.productOption.product_height_inches
      ) {
        dimensions = `${this.props.productOption.product_width_inches}" x ${this.props.productOption.product_height_inches}"`;
      } else if (this.props.productOption.product_width_inches) {
        dimensions = `${this.props.productOption.product_width_inches}"`;
      } else if (this.props.productOption.product_height_inches) {
        dimensions = `${this.props.productOption.product_height_inches}"`;
      }
    }

    return (
      <p className="dimensions">{dimensions && `approx. ${dimensions}`}</p>
    );
  }
}

function mapStateToProps(state) {
  return {
    design: state.design.present,
    productOption: state.productOption.entity,
  };
}

export default connect(mapStateToProps)(Dimensions);
